import { render, staticRenderFns } from "./HandbookOverview.vue?vue&type=template&id=8dd83454&"
import script from "./HandbookOverview.vue?vue&type=script&lang=js&"
export * from "./HandbookOverview.vue?vue&type=script&lang=js&"
import style0 from "./HandbookOverview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports